export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '快速导航',
      items: [
        { label: '最新快讯', href: '#updates' },
        { label: '焦点爆料', href: '#carousel' },
        { label: '话题热榜', href: '#topics' },
        { label: '深度爆料', href: '#cards' },
        { label: '爆料榜单', href: '#ranking' },
      ],
    },
    {
      title: '关于我们',
      items: [
        { label: '平台介绍', href: '#about' },
        { label: '平台优势', href: '#features' },
        { label: '常见问题', href: '#faq' },
        { label: '投稿爆料', href: '#contact' },
      ],
    },
    {
      title: '合作伙伴',
      items: [],
    },
    {
      title: '关注我们',
      items: [
        { label: '移动爆料', href: '#app' },
        { label: '网友热议', href: '#comments' },
      ],
    },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="section-container section-py">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
                {section.title}
              </h4>
              {section.items.length > 0 ? (
                <ul className="space-y-2.5">
                  {section.items.map((item) => (
                    <li key={item.label}>
                      <a
                        href={item.href}
                        onClick={(e) => handleClick(e, item.href)}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-background-500">暂无合作伙伴信息</p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-background-500">
            <p>51爆料网 — 每日大赛爆料第一站。聚焦51爆料每日大赛、51吃瓜爆料每日大赛，汇集热门比赛爆料与大赛合集，每日更新最新赛事动态与热议事件。</p>
          </div>
          <div className="text-xs text-background-600 whitespace-nowrap">
            &copy; {currentYear} 51爆料网 版权所有
          </div>
        </div>
      </div>
    </footer>
  );
}